const common = {
  // Navbar
  "nav.home": "主頁",
  "nav.about": "關於我們",
  "nav.about.intro": "科學院簡介",
  "nav.about.org": "組織結構",
  "nav.about.inquiry": "網上查詢",
  "nav.research": "研究成果",
  "nav.partners": "合作機構",
  "nav.partners.huaqiao": "華僑大學國際品牌研究院",
  "nav.news": "動態報道",
  "nav.news.articles": "新聞報道",
  "nav.news.brand": "品牌網報道",
  "nav.news.conference": "第二屆世界品牌大會暨世界品牌日",
  "nav.rankings": "品牌榜單",
  "nav.rankings.top100": "2025 中國品牌國際化標桿 100 強榜單",
  "nav.contact": "聯絡我們",
  "nav.menu": "IABS 選單",
  "nav.close": "關閉",
  "nav.search": "搜尋",
  "nav.searchPlaceholder": "搜尋科學院文章、榜單、活動……",
  "nav.hotSearch": "熱門搜尋：世界品牌日、品牌評估、稻米產區、紡織服飾",
  "nav.announcement": "The 2nd World Brand Conference in Hong Kong · 第二屆世界品牌大會．香港",

  // Hero
  "hero.badge": "2026 · HONG KONG",
  "hero.title.line1": "世界品牌日",
  "hero.title.line2": "落戶香港",
  "hero.description": "國際品牌科學院（IABS）與粵港澳大灣區企業家聯盟、國際品牌網聯合主辦，彰顯香港作為「世界品牌之都」及國際品牌中心的戰略定位，促進全球品牌合作與可持續發展。",
  "hero.cta.learn": "了解世界品牌日",
  "hero.cta.about": "認識國際品牌科學院",
  "hero.declaration.label": "大會宣言",
  "hero.declaration.quote": "「香港將積極對接國家『十五五』規劃，強化品牌建設，推動香港建設世界品牌中心。」",
  "hero.declaration.name": "李家超",
  "hero.declaration.title": "香港特區行政長官",
  "hero.scroll": "捲動",

  // FeatureStory
  "feature.label": "香港特區行政長官致辭",
  "feature.title.part1": "世界品牌日落戶香港特首李家超：",
  "feature.title.part2": "香港建設世界品牌中心意義重大",
  "feature.p1": "香港特區行政長官李家超在致辭中強調，「世界品牌日」落戶香港、支持香港建設世界品牌中心別具意義。國家「十五五」規劃要求建設品牌強國。「一國兩制」下的香港擁有「背靠祖國、聯通世界」的獨特優勢，是國家企業和品牌走向全球的重要平台。",
  "feature.p2": "李家超特首指出，香港的知識產權制度廣受認同，為品牌的創立、管理、授權和商品化提供全面保障。特區政府會持續優化商標註冊制度，積極打擊侵權行為。在穩健而透明的制度環境下，香港品牌可以安心創新、拓展市場、提升價值。",
  "feature.cta.read": "閱讀致辭全文",
  "feature.cta.watch": "觀看視頻致辭",
  "feature.stat.1.label": "規劃強國品牌",
  "feature.stat.2.label": "屆世界品牌大會",
  "feature.stat.3.label": "國際專家代表",
  "feature.date.label": "MAY 2026",
  "feature.date.location": "HONG KONG",

  // StatsSection
  "stats.established": "香港註冊成立",
  "stats.taxExempt": "免稅資格認可",
  "stats.brandPartners": "國際品牌合作",
  "stats.countries": "國家與地區覆蓋",

  // NewsSection
  "news.title": "動態報道",
  "news.description": "新華社、香港商報、國際品牌網及全球主流媒體，全方位追蹤 IABS 主辦活動與品牌研究最新進展。",
  "news.viewAll": "瀏覽全部新聞",
  "news.learnMore": "了解更多",
  "news.category.speech": "致辭 · 政策",
  "news.category.event": "活動 · 報道",

  // DeclarationBanner
  "declaration.quote": "以品牌之力，共塑全球新秩序。",
  "declaration.attribution": "— 世界品牌日．大會宣言（2026）",
  "declaration.cta.read": "閱讀完整宣言",
  "declaration.cta.download": "下載新聞稿",

  // RankingsSection
  "rankings.label": "官方排名",
  "rankings.title": "全球品牌權威榜單",
  "rankings.description": "以「品牌價值發展五要素理論」為核心方法論，涵蓋品質、服務、技術創新、有形與無形資產五大維度。",
  "rankings.viewFull": "查看完整榜單",

  // PartnersMarquee
  "partners.label": "我們的合作夥伴",
  "partners.title": "合作機構．與世界同行",

  // Newsletter
  "newsletter.label": "NEWSLETTER",
  "newsletter.title": "訂閱我們的電子郵件",
  "newsletter.description": "搶先收到 IABS 榜單發布、世界品牌日活動及專家觀點。",
  "newsletter.placeholder": "請輸入您的電子郵件地址",
  "newsletter.subscribe": "立即訂閱",
  "newsletter.submitting": "提交中…",
  "newsletter.success": "感謝訂閱！我們將盡快為您送上最新品牌動態。",
  "newsletter.successShort": "感謝訂閱，我們將盡快為您送上最新消息。",
  "newsletter.error": "網絡連線失敗，請稍後再試。",
  "newsletter.privacy": "我們尊重您的隱私，不會向第三方分享您的資料。",

  // Footer
  "footer.brand.name": "國際品牌科學院",
  "footer.brand.subtitle": "INTERNATIONAL ACADEMY OF BRAND SCIENCE",
  "footer.brand.desc": "國際品牌科學院（IABS）為非官方、非牟利國際學術機構，2022年在香港註冊成立。以「品牌價值發展五要素理論」為核心，致力構建全球權威的品牌評估體系。",
  "footer.quickLinks": "快速連結",
  "footer.link.intro": "科學院簡介",
  "footer.link.org": "組織結構",
  "footer.link.research": "研究成果",
  "footer.link.rankings": "品牌榜單",
  "footer.link.news": "動態報道",
  "footer.contact": "聯絡我們",
  "footer.address": "香港北角英皇道 395 號",
  "footer.copyright": "© 2026 IABS · International Academy of Brand Science · GT TECHNOLOGY LTD",
  "footer.privacy": "隱私政策",
  "footer.terms": "使用條款",
  "footer.sitemap": "網站地圖",

  // Breadcrumb
  "breadcrumb.home": "首頁",

  // About Introduction
  "about.intro.title": "國際品牌科學院簡介",
  "about.intro.subtitle": "International Academy of Brand Science (IABS)",
  "about.intro.mission": "使命與願景",
  "about.intro.mission.p1": "國際品牌科學院（International Academy of Brand Science，簡稱IABS）於2025年在香港正式註冊成立，是一家專注於品牌科學研究、品牌價值評估、品牌國際化推廣的國際性學術機構。科學院以「推動品牌科學發展，助力品牌走向世界」為使命，致力於建立全球公認的品牌評估標準體系，促進品牌經濟的繁榮與可持續發展。",
  "about.intro.mission.p2": "作為連接學術研究與產業實踐的重要橋樑，國際品牌科學院匯聚了來自全球各地的品牌研究專家、產業領袖和學術權威，共同推動品牌科學的前沿研究與實踐應用，為全球品牌建設提供科學、權威、公正的智力支持。",
  "about.intro.values": "核心價值",
  "about.intro.values.0.title": "科學性",
  "about.intro.values.0.desc": "以嚴謹的學術研究和數據分析為基礎，確保品牌評估的客觀性與準確性",
  "about.intro.values.1.title": "國際性",
  "about.intro.values.1.desc": "匯聚全球品牌研究資源，建立具有國際影響力的品牌評價標準",
  "about.intro.values.2.title": "公正性",
  "about.intro.values.2.desc": "堅持獨立、公正的評估原則，維護品牌評價的公信力與權威性",
  "about.intro.values.3.title": "創新性",
  "about.intro.values.3.desc": "持續探索品牌科學前沿，引領品牌研究與實踐的創新發展",
  "about.intro.functions": "主要職能",
  "about.intro.functions.0.title": "品牌評估與認證",
  "about.intro.functions.0.desc": "建立科學的品牌價值評估模型，開展品牌價值評估、品牌強度認證等專業服務，為企業和社會提供權威的品牌價值判斷依據。",
  "about.intro.functions.1.title": "品牌研究與智庫",
  "about.intro.functions.1.desc": "開展品牌科學基礎理論研究與應用研究，發布年度品牌研究報告、行業白皮書和品牌發展指數，建設全球品牌智庫。",
  "about.intro.functions.2.title": "品牌國際化推廣",
  "about.intro.functions.2.desc": "舉辦世界品牌大會、世界品牌日等國際性品牌盛會，搭建品牌國際交流合作平台，推動中國品牌及全球優秀品牌走向世界。",
  "about.intro.functions.3.title": "人才培養與交流",
  "about.intro.functions.3.desc": "建立品牌科學人才培養體系，開展品牌管理專業培訓、學術研討和國際交流，培育具有全球視野的品牌管理人才。",
  "about.intro.sidebar.quickLinks": "快速連結",
  "about.intro.sidebar.contact": "聯絡我們",
  "about.intro.sidebar.contact.desc": "如有任何查詢，歡迎與我們聯繫。我們的團隊將盡快回覆您的問題。",
  "about.intro.sidebar.contact.btn": "聯絡我們",

  // About Organization
  "about.org.title": "組織結構",
  "about.org.subtitle": "科學健全的組織架構，保障科學院高效運作",
  "about.org.leadership": "領導架構",
  "about.org.council": "理事會",
  "about.org.council.desc": "理事會是科學院的最高決策機構，負責制定科學院的戰略發展方向、審議重大事項和年度工作計劃。",
  "about.org.council.m0": "理事長一名",
  "about.org.council.m1": "副理事長三名",
  "about.org.council.m2": "常務理事若干名",
  "about.org.council.m3": "理事若干名",
  "about.org.board": "董事會",
  "about.org.board.desc": "董事會負責科學院的日常運營管理和資源配置，確保各項工作的順利開展與高效執行。",
  "about.org.board.m0": "董事長一名",
  "about.org.board.m1": "執行董事兩名",
  "about.org.board.m2": "董事若干名",
  "about.org.expert": "專家委員會",
  "about.org.expert.desc": "專家委員會是科學院的學術核心，由國內外知名品牌研究專家和產業權威組成，負責學術指導和品牌評估標準制定。",
  "about.org.expert.m0": "主任委員一名",
  "about.org.expert.m1": "副主任委員三名",
  "about.org.expert.m2": "專家委員若干名",
  "about.org.departments": "職能部門",
  "about.org.departments.desc": "科學院下設六大職能部門，各司其職、協同運作",
  "about.org.dept.0.name": "品牌評估中心",
  "about.org.dept.0.desc": "負責品牌價值評估模型研究、品牌評估項目實施、品牌評估報告編製與發布。",
  "about.org.dept.1.name": "學術研究部",
  "about.org.dept.1.desc": "負責品牌科學基礎研究、應用研究、學術期刊編輯出版及學術交流活動組織。",
  "about.org.dept.2.name": "國際合作部",
  "about.org.dept.2.desc": "負責國際合作夥伴關係建立與維護、國際品牌交流活動策劃與組織實施。",
  "about.org.dept.3.name": "品牌推廣部",
  "about.org.dept.3.desc": "負責世界品牌大會、世界品牌日等品牌活動的策劃組織及品牌國際化推廣服務。",
  "about.org.dept.4.name": "教育培訓部",
  "about.org.dept.4.desc": "負責品牌管理人才培養體系建設、專業培訓課程開發及學術研討會組織。",
  "about.org.dept.5.name": "行政辦公室",
  "about.org.dept.5.desc": "負責科學院日常行政管理、人力資源、財務管理及後勤保障等綜合事務。",
  "about.org.chart": "組織架構圖",
  "about.org.chart.council": "理事會",
  "about.org.chart.council.sub": "最高決策機構",
  "about.org.chart.board": "董事會",
  "about.org.chart.board.sub": "運營管理機構",
  "about.org.chart.expert": "專家委員會",
  "about.org.chart.expert.sub": "學術指導機構",

  // About Inquiry
  "about.inquiry.title": "網上查詢",
  "about.inquiry.subtitle": "如有任何疑問，歡迎通過以下表格與我們聯繫",
  "about.inquiry.form.title": "查詢表格",
  "about.inquiry.name": "姓名",
  "about.inquiry.email": "電郵",
  "about.inquiry.organization": "機構 / 公司",
  "about.inquiry.type": "查詢類別",
  "about.inquiry.type.placeholder": "請選擇查詢類別",
  "about.inquiry.type.general": "一般查詢",
  "about.inquiry.type.cooperation": "合作洽詢",
  "about.inquiry.type.research": "學術研究",
  "about.inquiry.type.evaluation": "品牌評估",
  "about.inquiry.type.event": "活動查詢",
  "about.inquiry.type.other": "其他",
  "about.inquiry.subject": "主題",
  "about.inquiry.message": "查詢內容",
  "about.inquiry.placeholder.name": "請輸入您的姓名",
  "about.inquiry.placeholder.email": "請輸入您的電郵地址",
  "about.inquiry.placeholder.org": "請輸入您的機構或公司名稱",
  "about.inquiry.placeholder.subject": "請輸入查詢主題",
  "about.inquiry.placeholder.message": "請詳細描述您的查詢內容（最多500字）",
  "about.inquiry.chars": "最多500個字符",
  "about.inquiry.submit": "提交查詢",
  "about.inquiry.honeypot.success": "查詢已成功提交",
  "about.inquiry.honeypot.desc": "感謝您的查詢，我們將在3個工作日內回覆。",
  "about.inquiry.honeypot.new": "提交新的查詢",
  "about.inquiry.error.network": "網絡錯誤，請檢查連接後重試",
  "about.inquiry.error.submit": "提交失敗，請稍後再試。",
  "about.inquiry.contact": "聯絡資訊",
  "about.inquiry.address.label": "地址",
  "about.inquiry.address": "香港北角英皇道395號",
  "about.inquiry.email.label": "電郵",
  "about.inquiry.phone.label": "電話",

  // Contact
  "contact.title": "聯絡我們",
  "contact.subtitle": "期待與您的交流與合作",
  "contact.form.title": "發送訊息",
  "contact.name": "姓名",
  "contact.email": "電郵",
  "contact.organization": "機構 / 公司",
  "contact.subject": "主題",
  "contact.message": "訊息內容",
  "contact.placeholder.name": "請輸入您的姓名",
  "contact.placeholder.email": "請輸入您的電郵地址",
  "contact.placeholder.org": "請輸入您的機構或公司名稱",
  "contact.placeholder.subject": "請輸入訊息主題",
  "contact.placeholder.message": "請輸入您的訊息（最多500字）",
  "contact.chars": "最多500個字符",
  "contact.submit": "發送訊息",
  "contact.success.title": "訊息已成功發送",
  "contact.success.desc": "感謝您的來信，我們將盡快回覆。",
  "contact.success.new": "發送新的訊息",
  "contact.honeypot.success": "訊息已成功發送",
  "contact.error.network": "網絡錯誤，請檢查連接後重試",
  "contact.error.submit": "提交失敗，請稍後再試。",
  "contact.info": "聯絡資訊",
  "contact.address.label": "地址",
  "contact.address": "香港北角英皇道395號",
  "contact.email.label": "電郵",
  "contact.phone.label": "電話",
  "contact.hours": "辦公時間",
  "contact.hours.weekday": "星期一至五",
  "contact.hours.saturday": "星期六",
  "contact.hours.sunday": "星期日及公眾假期",
  "contact.hours.closed": "休息",

  // News Articles
  "news.articles.title": "新聞報道",
  "news.articles.subtitle": "即時掌握國際品牌科學院最新動態與品牌領域前沿資訊",
  "news.articles.all": "全部",
  "news.articles.category.brand": "品牌動態",
  "news.articles.category.academic": "學術活動",
  "news.articles.category.report": "研究發布",
  "news.articles.category.org": "機構動態",
  "news.articles.category.international": "國際合作",

  // News Brand
  "news.brand.title": "品牌網報道",
  "news.brand.subtitle": "權威品牌研究報告與深度行業分析",
  "news.brand.coverage.heading": "蔡冠深博士在致辭中強調，世界品牌日落戶香港，是榮耀更是使命",
  "news.brand.coverage.intro": "中國外交部駐港公署副特派員李永勝，全國政協常委、國際品牌科學院董事會主席蔡冠深博士，中央駐港聯絡辦經濟部部長徐衛剛，ISO/TC289 品牌評價技術委員會候任主席等國際知名的品牌標準及評價體系專家，韓國、芬蘭、越南、哈薩克斯坦、奧地利、老撾六個國家的駐港總領事或副領事，全國人大代表、政協委員，香港立法會議員，以及來自中外知名企業家、香港六大商會首腦等四百多人出席了活動。",
  "news.brand.coverage.quote": "蔡冠深博士在致辭中強調，世界品牌日落戶香港，是榮耀更是使命。香港作為享譽全球的國際金融、貿易與航運中心，憑藉「一國兩制」的獨特優勢、健全的法治環境、強大的專業服務能力以及連通中外的超級樞紐地位，承載世界級品牌盛會實至名歸。這不僅是對香港這個全球最自由經濟體營商環境的高度認可，更為中國的品牌強國戰略，注入了強勁的新動能。對世界而言，此舉標誌着一個更加公正、多元、開放的全球品牌評價與交流新平台正在崛起，必將深刻推動世界品牌合作新格局的形成。",
  "news.brand.coverage.readMore": "閱讀完整報道",

  // News Conference
  "news.conference.title": "第二屆世界品牌大會暨世界品牌日",
  "news.conference.subtitle": "匯聚全球品牌智慧，共創品牌美好未來",
  "news.conference.date": "2026年5月10日 | 香港會議展覽中心",
  "news.conference.register": "報名參會",
  "news.conference.learnMore": "了解更多",
  "news.conference.info.date": "日期",
  "news.conference.info.dateVal": "2026年5月10日",
  "news.conference.info.location": "地點",
  "news.conference.info.locationVal": "香港會議展覽中心",
  "news.conference.info.scale": "預計規模",
  "news.conference.info.scaleVal": "1,000+ 與會者",
  "news.conference.info.countries": "覆蓋國家",
  "news.conference.info.countriesVal": "30+ 國家和地區",
  "news.conference.agenda": "大會議程",
  "news.conference.agenda.desc": "精彩議程，不容錯過",
  "news.conference.agenda.0.time": "09:00 - 09:30",
  "news.conference.agenda.0.title": "開幕典禮",
  "news.conference.agenda.0.desc": "主禮嘉賓致辭及開幕儀式，宣布第二屆世界品牌大會正式開幕",
  "news.conference.agenda.1.time": "09:30 - 10:30",
  "news.conference.agenda.1.title": "主旨演講：全球品牌發展新趨勢",
  "news.conference.agenda.1.desc": "國際知名品牌學者分享全球品牌發展的最新趨勢與前瞻洞見",
  "news.conference.agenda.2.time": "10:30 - 11:00",
  "news.conference.agenda.2.title": "茶歇及交流",
  "news.conference.agenda.2.desc": "與會嘉賓自由交流，建立品牌合作網絡",
  "news.conference.agenda.3.time": "11:00 - 12:30",
  "news.conference.agenda.3.title": "圓桌論壇：品牌國際化的機遇與挑戰",
  "news.conference.agenda.3.desc": "多位國際品牌領袖共同探討品牌國際化路徑與策略",
  "news.conference.agenda.4.time": "12:30 - 14:00",
  "news.conference.agenda.4.title": "午餐交流會",
  "news.conference.agenda.4.desc": "享用精緻午餐，與行業精英深度交流",
  "news.conference.agenda.5.time": "14:00 - 15:30",
  "news.conference.agenda.5.title": "平行分論壇",
  "news.conference.agenda.5.desc": "多個平行分論壇同步進行，涵蓋品牌評估、數字營銷、可持續發展等主題",
  "news.conference.agenda.6.time": "15:30 - 16:00",
  "news.conference.agenda.6.title": "茶歇",
  "news.conference.agenda.6.desc": "中場休息，自由交流",
  "news.conference.agenda.7.time": "16:00 - 17:30",
  "news.conference.agenda.7.title": "品牌榜單發布儀式",
  "news.conference.agenda.7.desc": "隆重發布年度品牌榜單，表彰優秀品牌",
  "news.conference.agenda.8.time": "17:30 - 18:00",
  "news.conference.agenda.8.title": "閉幕典禮",
  "news.conference.agenda.8.desc": "總結大會成果，展望未來發展",
  "news.conference.agenda.9.time": "18:30 - 21:00",
  "news.conference.agenda.9.title": "世界品牌之夜晚宴",
  "news.conference.agenda.9.desc": "盛大晚宴，品牌精英薈萃，共襄盛舉",
  "news.conference.speakers": "演講嘉賓",
  "news.conference.speakers.desc": "全球品牌領域頂尖專家雲集",
  "news.conference.speaker.0.name": "Prof. David Aaker",
  "news.conference.speaker.0.title": "品牌學奠基人",
  "news.conference.speaker.0.topic": "品牌建設的未來",
  "news.conference.speaker.1.name": "陳宇新教授",
  "news.conference.speaker.1.title": "上海交通大學教授",
  "news.conference.speaker.1.topic": "數字時代的品牌價值創造",
  "news.conference.speaker.2.name": "Dr. Jean-Noël Kapferer",
  "news.conference.speaker.2.title": "國際奢侈品牌權威",
  "news.conference.speaker.2.topic": "奢侈品牌的全球化策略",
  "news.conference.speaker.3.name": "張明德先生",
  "news.conference.speaker.3.title": "IABS董事長",
  "news.conference.speaker.3.topic": "品牌科學助力世界品牌之都建設",
  "news.conference.speaker.4.name": "Prof. Kevin Lane Keller",
  "news.conference.speaker.4.title": "達特茅斯學院教授",
  "news.conference.speaker.4.topic": "戰略品牌管理新範式",
  "news.conference.speaker.5.name": "Prof. Bernd Schmitt",
  "news.conference.speaker.5.title": "哥倫比亞大學教授",
  "news.conference.speaker.5.topic": "體驗營銷與品牌創新",

  // Partners Huaqiao
  "partners.huaqiao.title": "華僑大學國際品牌研究院",
  "partners.huaqiao.subtitle": "攜手共建，推動品牌科學研究與人才培養",
  "partners.huaqiao.intro": "合作夥伴簡介",
  "partners.huaqiao.intro.p1": "華僑大學國際品牌研究院是華僑大學下設的專業品牌研究機構，依托華僑大學深厚的學術底蘊和廣泛的國際聯繫，致力於品牌科學研究、品牌人才培養和品牌國際化服務。",
  "partners.huaqiao.intro.p2": "華僑大學是中國著名的綜合性大學，創辦於1960年，直屬中央統戰部領導。學校在品牌管理、市場營銷、國際貿易等領域具有突出的學術優勢和豐富的研究經驗，是中國品牌研究的重要學術基地之一。",
  "partners.huaqiao.areas": "合作領域",
  "partners.huaqiao.area.0.title": "聯合研究",
  "partners.huaqiao.area.0.desc": "共同開展品牌科學基礎理論與應用研究項目，發布聯合研究報告。",
  "partners.huaqiao.area.1.title": "人才培養",
  "partners.huaqiao.area.1.desc": "共建品牌管理碩士和博士培養項目，開展品牌專業人才培訓。",
  "partners.huaqiao.area.2.title": "國際交流",
  "partners.huaqiao.area.2.desc": "共同舉辦國際品牌學術會議和研討會，促進國際學術交流與合作。",
  "partners.huaqiao.area.3.title": "數據共享",
  "partners.huaqiao.area.3.desc": "共建品牌研究數據庫，共享品牌評估數據和研究資源。",
  "partners.huaqiao.results": "合作成果",
  "partners.huaqiao.result.0": "聯合發布《中國品牌國際化發展報告2025》，系統分析中國品牌國際化進程與趨勢",
  "partners.huaqiao.result.1": "共同舉辦「品牌科學前沿國際研討會」，吸引來自20多個國家的200餘位專家學者參加",
  "partners.huaqiao.result.2": "共建品牌管理碩士聯合培養項目，首屆招生30名研究生",
  "partners.huaqiao.result.3": "聯合申報國家級品牌研究課題3項，獲得科研經費支持",
  "partners.huaqiao.sidebar.title": "華僑大學",
  "partners.huaqiao.sidebar.founded": "成立時間",
  "partners.huaqiao.sidebar.foundedVal": "1960年",
  "partners.huaqiao.sidebar.location": "所在地",
  "partners.huaqiao.sidebar.locationVal": "福建省廈門市 / 泉州市",
  "partners.huaqiao.sidebar.authority": "主管部門",
  "partners.huaqiao.sidebar.authorityVal": "中央統戰部",
  "partners.huaqiao.sidebar.type": "學校類型",
  "partners.huaqiao.sidebar.typeVal": "綜合性大學",
  "partners.huaqiao.sidebar.other": "其他合作機構",
  "partners.huaqiao.sidebar.other.desc": "更多合作機構資訊即將公佈，敬請期待。",

  // Rankings
  "rankings.top100.title": "2025 中國品牌國際化標桿 100 強榜單",
  "rankings.top100.subtitle": "國際品牌科學院聯合華僑大學國際品牌研究院權威發布",
  "rankings.top100.badge": "2025年度榜單 · 數據截止2025年11月",
  "rankings.top100.method.market": "品牌市場表現",
  "rankings.top100.method.market.desc": "海外營收佔比、市場份額增速",
  "rankings.top100.method.cognition": "品牌國際認知",
  "rankings.top100.method.cognition.desc": "海外消費者認知度、媒體曝光度",
  "rankings.top100.method.innovation": "品牌創新能力",
  "rankings.top100.method.innovation.desc": "國際專利數量、研發投入強度",
  "rankings.top100.method.esg": "品牌社會責任",
  "rankings.top100.method.esg.desc": "ESG評級、可持續發展實踐",
  "rankings.top100.table.title": "榜單排名（前20強）",
  "rankings.top100.table.desc": "展示2025年度中國品牌國際化標桿100強中的前20名",
  "rankings.top100.table.rank": "排名",
  "rankings.top100.table.name": "品牌名稱",
  "rankings.top100.table.industry": "行業",
  "rankings.top100.table.score": "國際化指數",
  "rankings.top100.table.change": "排名變化",
  "rankings.top100.table.country": "國家/地區",
  "rankings.top100.footer": "以上展示為前20強，完整100強榜單請聯繫國際品牌科學院獲取",
  "rankings.top100.cta.title": "獲取完整榜單報告",
  "rankings.top100.cta.desc": "如需獲取完整的《2025中國品牌國際化標桿100強》榜單及詳細分析報告，請與我們聯繫。",
  "rankings.top100.cta.btn": "聯絡我們獲取完整報告",

  "rankings.top100.more.title": "更多 IABS 品牌榜單",
  "rankings.top100.more.desc": "探索國際品牌科學院發布的不同行業權威品牌評估成果。",
  "rankings.top100.reports.0.title": "《世界稻米產區三十強》及《世界稻米地理標誌（縣域）品牌百強》榜單發布",
  "rankings.top100.reports.0.desc": "9月22日，由國際品牌科學院、華僑大學國際品牌研究院、國際品牌網、國際稻香米品牌中心及綏化市人民政府共同主辦的國際稻香米品牌大會暨慶安大米品牌發展交流會在黑龍江省慶安縣召開，來自全球的行業精英、專家學者、企業家及媒體代表等約300人齊聚一堂。",
  "rankings.top100.reports.1.title": "《2024世界紡織服飾品牌強度評估結果》",
  "rankings.top100.reports.1.desc": "9月20日，2024紡織服裝品牌發展大會在常熟舉行。會上，國際品牌科學院發表了《2024世界紡織服飾品牌強度評估結果》。\n\n據介紹，依照《紡織服裝品牌評價準則》，國際紡織服裝品牌評估專家小組對來自16個國家的200餘個品牌進行綜合評價。此評估數據由國際權威的市場研究公司歐睿國際提供，依據定量數據和定性分析，從市場、創新、服務、無形、有形五個維度進行品牌強度評價，最終評選出排名前100的產品品牌。\n\n在今年的榜單中，有16個中國紡織服裝品牌榜上有名，其中，波司登品牌強度位列全球第八位，雅戈爾則名列第十八位。這不僅是對中國品牌的高度認可，更是中國品牌實力和影響力的有力彰顯。",
  "rankings.top100.reports.2.title": "2023《世界蒸餾酒十大產區》及《世界蒸餾酒品牌榜》發布",
  "rankings.top100.reports.2.desc": "2023年10月25日，「國際蒸餾酒品牌大會」在瀘州郎酒莊園隆重舉行。大會由國際品牌科學院、國際蒸餾酒品牌中心及國際品牌網主辦，中國品牌建設促進會、中國食品工業協會、品牌中國戰略規劃院協辦，瀘州市人民政府、中國國家品牌網承辦。\n\n本次大會以「世界美酒·人類共享」為主題，旨在透過不斷優化和提升世界蒸餾酒品牌價值，健全酒類飲品品牌文化體系，推動全球酒類生產經營優勢企業交流與合作，構建以優質美酒和知名品牌服務於人類美好生活需要的可持續發展共識。",
  "rankings.top100.reports.3.title": "國際葡萄酒產區品牌榜單公佈，寧夏賀蘭山東麓排名第四！",
  "rankings.top100.reports.3.desc": "10月6日，第三屆寧夏賀蘭山東麓國際葡萄酒大賽暨首屆布魯塞爾「馬瑟蘭」國際葡萄酒大賽頒獎盛典上，國際葡萄酒產區品牌榜及國際葡萄酒產品品牌榜正式公佈，寧夏賀蘭山東麓位列國際葡萄酒產區品牌榜第四位。19個中國品牌入選國際葡萄酒產品品牌榜，其中，寧夏賀蘭山東麓葡萄酒本土品牌8個。",
  "rankings.top100.reports.learnMore": "了解更多",

  // Research
  "research.title": "研究成果",
  "research.subtitle": "嚴謹的學術研究，科學的品牌洞見",
  "research.projects": "研究項目",
  "research.projects.desc": "科學院正在進行的重點研究課題",
  "research.projects.0.title": "品牌價值評估模型研究",
  "research.projects.0.abstract": "本研究旨在建立一套科學、系統的品牌價值評估模型，結合財務指標、市場表現和消費者認知等多維度數據，為品牌價值量化提供權威的評估方法論。",
  "research.projects.0.kw0": "品牌評估",
  "research.projects.0.kw1": "價值模型",
  "research.projects.0.kw2": "多維度分析",
  "research.projects.0.category": "基礎研究",
  "research.projects.1.title": "中國品牌國際化路徑研究",
  "research.projects.1.abstract": "聚焦中國品牌在全球市場的國際化進程，分析成功案例與失敗教訓，提煉可供借鑒的品牌國際化策略框架和實施路徑。",
  "research.projects.1.kw0": "品牌國際化",
  "research.projects.1.kw1": "中國品牌",
  "research.projects.1.kw2": "全球化策略",
  "research.projects.1.category": "應用研究",
  "research.projects.2.title": "數字時代品牌傳播新模式",
  "research.projects.2.abstract": "探索社交媒體、人工智能、元宇宙等新興技術對品牌傳播的影響，研究數字化時代品牌與消費者互動的新範式和最佳實踐。",
  "research.projects.2.kw0": "數字營銷",
  "research.projects.2.kw1": "社交媒體",
  "research.projects.2.kw2": "品牌傳播",
  "research.projects.2.category": "前沿研究",
  "research.projects.3.title": "全球品牌競爭力指數研究",
  "research.projects.3.abstract": "構建全球品牌競爭力評價指標體系，對世界主要經濟體的品牌競爭力進行系統評估和比較分析，為各國品牌政策制定提供數據支持。",
  "research.projects.3.kw0": "競爭力指數",
  "research.projects.3.kw1": "全球比較",
  "research.projects.3.kw2": "品牌政策",
  "research.projects.3.category": "基礎研究",
  "research.projects.4.title": "可持續發展與品牌價值",
  "research.projects.4.abstract": "研究ESG（環境、社會和公司治理）因素對品牌價值的影響機制，探討可持續發展理念如何重塑品牌建設和品牌管理實踐。",
  "research.projects.4.kw0": "ESG",
  "research.projects.4.kw1": "可持續發展",
  "research.projects.4.kw2": "品牌價值",
  "research.projects.4.category": "前沿研究",
  "research.projects.5.title": "區域品牌與產業集群研究",
  "research.projects.5.abstract": "以粵港澳大灣區為重點案例，研究區域品牌建設與產業集群發展的互動關係，為區域經濟一體化背景下的品牌戰略提供理論支撐。",
  "research.projects.5.kw0": "區域品牌",
  "research.projects.5.kw1": "大灣區",
  "research.projects.5.kw2": "產業集群",
  "research.projects.5.category": "應用研究",
  "research.publications": "出版成果",
  "research.publications.desc": "已發布的研究報告與學術出版物",
  "research.pub.0.type": "年度報告",
  "research.pub.0.date": "2025年12月",
  "research.pub.0.title": "《世界品牌發展報告2025》",
  "research.pub.0.desc": "全面分析全球品牌發展趨勢，涵蓋品牌價值評估、品牌國際化進程、品牌數字化轉型等核心議題。",
  "research.pub.1.type": "研究報告",
  "research.pub.1.date": "2025年10月",
  "research.pub.1.title": "《中國品牌國際化標桿研究》",
  "research.pub.1.desc": "深入研究中國品牌國際化的成功案例與經驗教訓，提煉品牌國際化的關鍵成功因素。",
  "research.pub.2.type": "學術期刊",
  "research.pub.2.date": "2025年9月",
  "research.pub.2.title": "《品牌科學前沿》學術期刊（創刊號）",
  "research.pub.2.desc": "國際品牌科學院官方學術期刊，發表品牌科學領域的最新研究成果和學術論文。",
  "research.pub.3.type": "白皮書",
  "research.pub.3.date": "2025年8月",
  "research.pub.3.title": "《粵港澳大灣區品牌發展白皮書》",
  "research.pub.3.desc": "系統分析粵港澳大灣區品牌發展現狀、機遇與挑戰，提出品牌建設策略建議。",

  // NotFound
  "notFound.title": "This page has not been generated",
  "notFound.subtitle": "Tell me more about this page, so I can generate it",

  // Language
  "language.en": "English",
  "language.zh": "繁體中文",
  "language.label": "Language",

  // Shared
  "weight": "權重",
  "common.required": "必填欄位",
};

export default common;